import { render, staticRenderFns } from "./IcoBriefcase.vue?vue&type=template&id=6582d0a6"
import script from "./IcoBriefcase.vue?vue&type=script&lang=js"
export * from "./IcoBriefcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports